var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 18 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M3.50415 11.345C3.50415 11.4167 3.4927 11.4286 3.43544 11.4286H2.26739C2.26739 11.4286 2.18723 11.4047 2.18723 11.3331V10.1986C1.40853 10.1747 0.606928 9.97167 0.0916118 9.67312C0.022903 9.62535 0 9.5537 0 9.44622V7.9654C0 7.89375 0.0687089 7.83404 0.125966 7.89375C0.904667 8.52668 1.92385 8.70581 2.63384 8.70581C3.52705 8.70581 4.09963 8.35949 4.09963 7.82209C4.09963 7.2847 3.75608 6.96226 2.47352 6.41293C0.584025 5.64863 0 4.93211 0 3.66625C0 2.48398 0.813055 1.45696 2.21013 1.21812V0.0836251C2.21013 0.0119726 2.22159 3.05176e-05 2.2903 3.05176e-05H3.44689C3.5156 3.05176e-05 3.52705 0.0119726 3.52705 0.0836251L3.57286 1.1823C4.21414 1.23006 4.92413 1.37337 5.27913 1.6361C5.32494 1.65998 5.33639 1.70775 5.33639 1.79134V3.20051C5.33639 3.27216 5.27913 3.29605 5.22187 3.27216C4.6722 2.84225 3.97366 2.57952 2.94303 2.57952C2.00401 2.57952 1.52305 2.99749 1.52305 3.48712C1.52305 3.97674 1.78643 4.2753 3.24077 4.89628C5.29058 5.74417 5.71429 6.604 5.71429 7.70267C5.71429 9.26709 4.46608 9.97167 3.50415 10.103V11.3331V11.345Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M12.9495 10.5352C13.5024 10.5352 13.9493 10.0883 13.9493 9.53537L13.9493 4.89675L15.7814 6.71048C16.1732 7.09797 16.8032 7.09585 17.1921 6.70694L17.1957 6.70341C17.5839 6.31096 17.581 5.67739 17.1886 5.28919L13.6375 1.77346C13.2465 1.38667 12.6164 1.38738 12.2275 1.77629L8.70755 5.29202L8.70684 5.29273C8.31652 5.68305 8.31652 6.3152 8.70613 6.70623C9.09716 7.09726 9.73002 7.09797 10.1211 6.70694L11.9496 4.87978L11.9496 9.53537C11.9496 10.0883 12.3965 10.5352 12.9495 10.5352Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }